import { Variants as t, OtherPaymentMethodsSizes as c, Sizes as y, BrandsWithCardNumber as $, Brands as o, SecondaryOnlyBrands as k } from "./atoms-v21222.js";
import { ColorThemes as g } from "./atoms-v21024.js";
const M = ({
  brand: r,
  colorTheme: n,
  isFullRounded: a = !1,
  isSkeleton: d,
  theme: i,
  variant: x
}) => {
  const s = () => {
    if (d)
      return i == null ? void 0 : i.get(`ui.button.primary.${n}.skeleton`);
  }, u = () => {
    if (r === o.paypal)
      return i == null ? void 0 : i.get("tokens.colors.paymentMethods.paypal");
    if (r === o.affirm)
      return i == null ? void 0 : i.get("tokens.colors.paymentMethods.affirm");
    if (r === o.visa)
      return i == null ? void 0 : i.get("tokens.colors.paymentMethods.visa");
    if (r === o.amex)
      return i == null ? void 0 : i.get("tokens.colors.paymentMethods.amex");
    if (r === o.diners)
      return i == null ? void 0 : i.get("tokens.colors.paymentMethods.diners");
    if (r === o.jcb)
      return i == null ? void 0 : i.get("tokens.colors.paymentMethods.jcb");
    if (r === o.discover)
      return i == null ? void 0 : i.get("tokens.colors.paymentMethods.discover");
  }, l = () => d ? i == null ? void 0 : i.get("tokens.radius.skeletonRadius") : a ? i == null ? void 0 : i.get("tokens.radius.buttonFullRounded") : i == null ? void 0 : i.get("tokens.radius.buttonSmallRounded"), p = () => {
    if (d)
      return "none";
  }, f = (b) => k.includes(r) ? `linear-gradient(0deg, ${i == null ? void 0 : i.get(
    `ui.button.secondary.${n}.${b}`
  )} 0%, ${i == null ? void 0 : i.get(`ui.button.secondary.${n}.${b}`)} 100%), ${u()}` : `${i == null ? void 0 : i.get(`ui.button.secondary.${n}.${b}`)}`;
  return {
    [t.primary]: {
      backgroundColor: s() || u() || (i == null ? void 0 : i.get(`ui.button.primary.${n}.bkg`)),
      borderRadius: l(),
      color: i == null ? void 0 : i.get(`ui.button.primary.${n}.text`),
      WebkitFontSmoothing: n === g.light ? "antialiased" : "subpixel-antialiased",
      padding: "5px 18px 2px",
      "&:hover": {
        background: s() || `linear-gradient(0deg, ${i == null ? void 0 : i.get(`ui.button.primary.${n}.hover`)} 0%, ${i == null ? void 0 : i.get(
          `ui.button.primary.${n}.hover`
        )} 100%), ${u() || (i == null ? void 0 : i.get(`ui.button.primary.${n}.bkg`))}`
      },
      "&:active": {
        backgroundColor: s() || `linear-gradient(0deg, ${i == null ? void 0 : i.get(`ui.button.primary.${n}.active`)} 0%, ${i == null ? void 0 : i.get(
          `ui.button.primary.${n}.active`
        )} 100%), ${u() || (i == null ? void 0 : i.get(`ui.button.primary.${n}.bkg`))}`
      },
      "&[disabled]": {
        backgroundColor: s() || (i == null ? void 0 : i.get(`ui.button.primary.${n}.disabled`)),
        color: i == null ? void 0 : i.get(`ui.button.primary.${n}.disabledText`),
        WebkitFontSmoothing: "subpixel-antialiased"
      },
      "&:focus-visible": {
        outline: p() || `1px solid ${i == null ? void 0 : i.get(`ui.button.primary.${n}.focus`)}`,
        outlineOffset: "-3px"
      }
    },
    [t.secondary]: {
      backgroundColor: s() || u(),
      border: `1px solid ${u() || (i == null ? void 0 : i.get(`ui.button.secondary.${n}.stroke`))}`,
      borderRadius: l(),
      color: i == null ? void 0 : i.get(`ui.button.secondary.${n}.text`),
      padding: "5px 18px 2px",
      WebkitFontSmoothing: n === g.light ? "antialiased" : "subpixel-antialiased",
      "&:hover": {
        background: s() || f("hover"),
        color: i == null ? void 0 : i.get(`ui.button.secondary.${n}.text`),
        WebkitFontSmoothing: "antialiased"
      },
      "&:active": {
        background: s() || f("active"),
        color: i == null ? void 0 : i.get(`ui.button.secondary.${n}.text`),
        WebkitFontSmoothing: n === g.light ? "antialiased" : "subpixel-antialiased"
      },
      "&[disabled]": {
        backgroundColor: s() || (i == null ? void 0 : i.get(`ui.button.secondary.${n}.disabled`)),
        color: i == null ? void 0 : i.get(`ui.button.secondary.${n}.disabledText`),
        outlineColor: i == null ? void 0 : i.get(`ui.button.secondary.${n}.disabledText`)
      },
      "&:focus-visible": {
        backgroundColor: s() || u() || "transparent",
        color: i == null ? void 0 : i.get(`ui.button.secondary.${n}.text`),
        outline: p() || `1px solid ${i == null ? void 0 : i.get(`ui.button.secondary.${n}.focus`)}`,
        outlineOffset: "-3px",
        WebkitFontSmoothing: n === g.light ? "antialiased" : "subpixel-antialiased"
      }
    },
    [t.otherPayments]: {
      border: `1px solid ${i == null ? void 0 : i.get(`tokens.border.${n}.light`)}`,
      borderRadius: l(),
      color: u() || (i == null ? void 0 : i.get(`ui.button.secondary.${n}.text`)),
      WebkitFontSmoothing: n === g.light ? "antialiased" : "subpixel-antialiased",
      padding: "5px 18px 2px",
      "&:hover": {
        border: `1px solid ${i == null ? void 0 : i.get(`tokens.border.${n}.dark`)}`
      },
      "&:active": {
        border: `1px solid ${i == null ? void 0 : i.get(`tokens.border.${n}.main`)}`
      },
      "&:focus-visible": {
        border: `1px solid ${i == null ? void 0 : i.get(`tokens.border.${n}.dark`)}`,
        outline: p() || `1px solid ${i == null ? void 0 : i.get(`ui.button.secondary.${n}.focus`)}`,
        outlineOffset: "-3px"
      }
    }
  }[x];
}, W = ({
  isSkeleton: r,
  size: n,
  theme: a,
  variant: d
}) => {
  if (r)
    return {
      maxHeight: "44px",
      minHeight: "44px"
    };
  switch (n) {
    case "small": {
      const i = a == null ? void 0 : a.get("tokens.body.compact-productive");
      return {
        ...i && i.toJS(),
        maxHeight: c.small,
        minHeight: c.small
      };
    }
    case "default":
    default: {
      const i = a == null ? void 0 : a.get("tokens.body.compact-expressive");
      return {
        ...i && i.toJS(),
        maxHeight: d === t.otherPayments ? c.default : y.default,
        minHeight: d === t.otherPayments ? c.default : y.default
      };
    }
  }
}, F = ({ brand: r }) => $.includes(r) ? "space-between" : "center", P = ({
  brand: r,
  isSkeleton: n,
  variant: a
}) => r === o.affirm ? "181px" : a === t.otherPayments && !n ? "280px" : $.includes(r) ? "234px" : "100px", R = ({ brand: r }) => r === o.applePay ? "cc-apple-pay" : r === o.googlePay ? "cc-google-pay" : r === o.paypal ? "cc-paypal" : r === o.affirm ? "cc-affirm" : r === o.visa ? "cc-visa" : r === o.amex ? "cc-amex" : r === o.diners ? "cc-diners" : r === o.jcb ? "cc-jcb" : r === o.discover ? "cc-discover" : r === o.mastercard ? "cc-mastercard" : r === o.newCard || r === o.card ? "account" : "placeholder";
export {
  R as getIconName,
  F as getJustifyContent,
  P as getMinWidth,
  W as getSize,
  M as getStyles
};
